import { mq } from "@/libs/react-responsive/mediaQuery";
import { color, image } from "@/theme";
import styled from "@emotion/styled";
import React from "react";

const StyledImage = styled.img(() => ({
  display: "block",
  maxWidth: "100%",
  margin: "0 auto",

  [mq("tablet")]: {
    maxWidth: "90%",
  },
}));

const Title = styled.h1(() => ({
  fontSize: "2rem",
  fontWeight: "bold",
  textAlign: "center",
  marginTop: "8rem",
  marginBottom: "4rem",

  [mq("desktop")]: {
    fontSize: "2.4rem",
  },
}));

const Description = styled.p(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  fontSize: "1.8rem",
  textAlign: "center",
  margin: "2rem auto",

  strong: {
    color: color.primary02,
  },

  b: {
    display: "block",
    marginTop: "2rem",
  },

  p: {
    fontSize: "1.6rem",
  },

  [mq("desktop")]: {
    maxWidth: "80%",
  },
}));

const InformationSection = styled.div(() => ({
  display: "flex",
  margin: "6rem 0 15rem",
  textAlign: "center",
  fontSize: "1.8rem",
  flexDirection: "column",
  gap: "1rem",

  [mq("desktop")]: {
    flexDirection: "row",
    gap: 0,
  },
}));

const InformationItem = styled.div(({ isNow }) => ({
  flex: 1,
  alignSelf: "stretch",
  fontSize: "1.8rem",
  color: isNow ? color.black01 : color.grey06,

  header: {
    border: `1px solid ${color.grey04}`,
    flex: 1,
    fontWeight: 600,
    padding: "1rem 0",

    [mq("desktop")]: {
      borderRight: isNow ? `1px solid ${color.grey04}` : "none",
    },
  },

  "& > div": {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    padding: "2rem 0",
    border: `1px solid ${color.grey04}`,
    borderTop: 0,

    [mq("desktop")]: {
      borderRight: isNow ? `1px solid ${color.grey04}` : "none",
    },
    flex: 1,
    height: "100%",
  },

  p: {
    color: isNow ? color.primary02 : "inherit",
    fontWeight: "bold",
    marginBottom: "1.6rem",
  },

  ul: {
    display: "flex",
    flexDirection: "column",
    gap: "0.4rem",
  },
}));

const ClosingText = styled.div(() => ({
  margin: "8rem 0",
}));

const ContestResult = () => {
  return (
    <section>
      <StyledImage src={image.changeEarthPoster2} alt="change-earth-poster" />

      <Title>[제1회 세이브더얼스 숏폼영상 공모전 결과 발표]</Title>

      <Description>
        <div>
          사단법인 세이브더얼스가 주최한 제1회 환경소재 숏폼영상 공모전
          <br /> <strong>‘97초 안에 지구를 지켜줘’</strong> 에 참여해 주신 모든
          분들께 진심으로 감사드립니다.
        </div>

        <div>
          이번 공모전에는 환경을 향한 진심 어린 메시지와 창의적인 시각이 담긴
          우수한 작품들이 다수 접수되었습니다.
        </div>

        <div>
          <b>
            이에 심사 결과, 당초 계획보다 수상 인원과 상금을 확대하여 아래와
            같이 최종 결과를 발표합니다.
          </b>

          <p>
            (※ 시상식 일정 및 수상 관련 안내는 개별 연락을 통해 진행됩니다.)
          </p>
        </div>
      </Description>

      <InformationSection>
        <InformationItem>
          <header>기존</header>

          <div>
            <p>총 7명 / 상금 200만원</p>

            <ul>
              <li>대상 : 1백만원 (1명)</li>
              <li>최우수상 : 50만원 (1명)</li>
              <li>우수상 : 30만원 (1명)</li>
            </ul>
          </div>
        </InformationItem>

        <InformationItem isNow>
          <header>변경</header>

          <div>
            <p>총 10명 / 상금 310만원</p>

            <ul>
              <li>대상 : 1백만원 (1명)</li>
              <li>최우수상 : 50만원 (2명)</li>
              <li>우수상 : 30만원 (3명)</li>
              <li>크리에이티브상 : 디지털 상품권 5만원권 (4명)</li>
            </ul>
          </div>
        </InformationItem>
      </InformationSection>

      <ClosingText>
        <Description>
          <div>
            사단법인 세이브더얼스는 앞으로도 환경을 지키는 뜻깊은 활동과 창의적
            참여의 장을 마련하기 위해 꾸준히 노력하겠습니다.
          </div>

          <b>
            다시 한 번, 귀중한 작품으로 함께해 주신 모든 분들께 감사드립니다.
          </b>
        </Description>
      </ClosingText>
    </section>
  );
};

export default ContestResult;
